"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHARE = exports.CANDLE = exports.DATA_EXPORT = exports.DATA_META = exports.DATA_UPLOAD = exports.ADMINS_PAGINATE = exports.ADMINS_DELETE = exports.ADMINS_UPDATE = exports.ADMINS_CREATE = exports.AUTH_SESSION_OUT = exports.AUTH_SESSION_IN = exports.AUTH_ADMIN = exports.ROOT = exports.API_HOST = void 0;
exports.API_HOST = "".concat(process.env.WEBSITE_DOMAIN_URL).concat(process.env.ENV === 'local' ? ":".concat(process.env.API_PORT) : '');
// as const is a type assertion that tells TypeScript that the value of ROOT is a string literal type:
// so in hints it will show you the value of ROOT as `/api` instead of `string`
exports.ROOT = "/api";
// Admin:
exports.AUTH_ADMIN = "".concat(exports.ROOT, "/auth/admin");
exports.AUTH_SESSION_IN = "".concat(exports.ROOT, "/auth/session-in");
exports.AUTH_SESSION_OUT = "".concat(exports.ROOT, "/auth/session-out");
exports.ADMINS_CREATE = "".concat(exports.ROOT, "/admins/create");
exports.ADMINS_UPDATE = "".concat(exports.ROOT, "/admins/update/:id");
exports.ADMINS_DELETE = "".concat(exports.ROOT, "/admins/delete/:id");
exports.ADMINS_PAGINATE = "".concat(exports.ROOT, "/admins/paginate");
exports.DATA_UPLOAD = "".concat(exports.ROOT, "/data/upload");
exports.DATA_META = "".concat(exports.ROOT, "/data/meta");
exports.DATA_EXPORT = "".concat(exports.ROOT, "/data/export");
// Client:
exports.CANDLE = "".concat(exports.ROOT, "/candle");
exports.SHARE = "".concat(exports.ROOT, "/share");
//# sourceMappingURL=routes.js.map